import React from 'react';
import './markov.css';
import AppStore from "../../assets/main/appstore.svg";

// Markov Files
import Screen1 from '../../assets/markov/mobile/screen1.webp';
import Screen2 from '../../assets/markov/mobile/screen2.webp';
import Screen3 from '../../assets/markov/mobile/screen3.webp';
import Screen4 from '../../assets/markov/mobile/screen4.webp';
import Screen5 from '../../assets/markov/mobile/screen5.webp';
import Screen6 from '../../assets/markov/mobile/screen6.webp';
import Screen7 from '../../assets/markov/mobile/screen7.webp';

import Policy from '../../assets/markov/privacy.pdf';

// Pagination
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

const data = [
  {
    avatar: Screen1
  },
  {
    avatar: Screen2
  },
  {
    avatar: Screen3
  },
  {
    avatar: Screen4
  },
  {
    avatar: Screen5
  },
  {
    avatar: Screen6
  },
  {
    avatar: Screen7
  }
]

const Markov = () => {
  return (
    <section id='markov'>
      <div className='container markov__container_top'>
      <div className='markov__container'>
        <Swiper className='noselect markov__screenshots'
          modules={[Pagination]}
          spaceBetween={40}
          slidesPerView={1}
          pagination={{ clickable: true, type: 'bullets' }}> {
            data.map(({avatar}, index) => {
              return (
              <SwiperSlide key={index} className='markov__screenshots'>
                  <img src={avatar} alt="" />
              </SwiperSlide>
              )
            })
         }
        </Swiper>
        <div className='markov__right'>
          <h1 className='noselect markov__title'>Markov Algorithm _<g> v</g><b>3.0</b></h1>
          <div className='about__content'>
            <p className='noselect'>
            Students of computer science are probably familiar with Markov algorithm. In theoretical computer science, a Markov algorithm is a string rewriting system that uses grammar-like rules to operate on strings of symbols. Markov algorithms have been shown to be Turing-complete, which means that they are suitable as a general model of computation and can represent any mathematical expression from its simple notation. Markov algorithms are named after the mathematician Andrey Markov, Jr. <a href='https://en.wikipedia.org/wiki/Markov_algorithm'>- Wikipedia</a>
            </p>
            <p className='noselect'>
              <a href={Policy} download='markov_policy.pdf'>Privacy Policy Agreement</a>
            </p>
            <div className='noselect markov__buttons'>
              <a className='appstore_container' href='https://apple.co/3ZAHLX1' aria-label="Download Markov Algorithm on the App Store">
                <img className='appstore' src={AppStore} alt="Download on the App Store" />
              </a>
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  )
}

export default Markov